import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { addDays } from 'date-fns'

import ConfirmationDialog from 'components/atoms/ConfirmationDialog'
import StaticDatePicker from 'components/atoms/StaticDatePicker'

export default function AssignmentConfirmationDialog({
  open,
  handleClose,
  handleSubmit,
  dateValue,
  setDateValue,
}) {
  const { t } = useTranslation()

  const [startDateValue, setStartDateValue] = useState()

  useEffect(() => {
    if (open) {
      const startDate = addDays(new Date(), 1)
      setDateValue(startDate)
      setStartDateValue(startDate)
    }
  }, [open, setDateValue])

  return (
    <ConfirmationDialog
      title={t('assignment.confirmationDialog.title')}
      contentComponent={Box}
      content={
        <>
          <Typography variant="body2">
            {t('assignment.confirmationDialog.content')}
          </Typography>
          <Box pb={3} />
          <Typography variant="body2">
            {t('assignment.confirmationDialog.datePicker.label')}
          </Typography>
          <StaticDatePicker
            value={dateValue}
            onChange={setDateValue}
            minDate={startDateValue}
          />
        </>
      }
      open={open}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    />
  )
}

AssignmentConfirmationDialog.propTypes = {
  open: T.bool,
  handleClose: T.func,
  handleSubmit: T.func,
}
